import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLEVENINGDOJISTAR', label: 'Evening Doji Star', lookback: 12, penetration: 0.3 })
